import { z } from '../index.ts'

export const GetStatusSchema = z.object({
  alias: z.string(),
  title: z.string(),
})
